import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { openBrowserAsync } from 'expo-web-browser';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTelemetry } from '@order/Telemetry';

/**
 * Featured flagged contact us handler.
 * Will open Sierra if its enabled.
 * Fallback to opening https://www.sweetgreen.com/contact.
 */
export const useContactUsHandler = (
  source:
    | 'account'
    | 'order-history'
    | 'org-links'
    | 'order-status'
    | 'scan'
    | 'home',
) => {
  const { track } = useTelemetry();

  const isSierraEnabled = useFeatureFlag('permanent-sierra-enabled');

  const { navigate } = useNavigation();

  const handleContactUs = useCallback(async () => {
    track('contact_us', {
      source,
      destination: getDestination(isSierraEnabled),
    });

    if (isSierraEnabled) {
      navigate('Modal', { screen: 'Chat' });

      return;
    }

    await openBrowserAsync('https://www.sweetgreen.com/contact', {
      windowFeatures: { target: '_blank' },
    });
  }, [source, isSierraEnabled, navigate, track]);

  return {
    handleContactUs,
    hasDynamicChat: isSierraEnabled,
  };
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

const getDestination = (isSierraEnabled: boolean) => {
  if (isSierraEnabled) return 'sierra';

  return 'website';
};
